import * as React from "react";

const ChevronSmallUp: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.50301 14.5C8.11248 14.8905 7.39353 14.8905 7.00301 14.5C6.61248 14.1095 6.61248 13.3905 7.00301 13L12.003 8.00001L17.003 13C17.3935 13.3905 17.3935 14.1095 17.003 14.5C16.6125 14.8905 15.8935 14.8905 15.503 14.5L12.003 11L8.50301 14.5Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronSmallUp);
